module.exports = __webpack_public_path__ + "static/personal-loans-9f4ba0d7ef5aff6aab6ccce97b05ef68.png";